import { z } from "zod";
 
// ── Helpers ───────────────────────────────────────────────
const requiredStr = (label) =>
  z.string().min(1, `${label} is required`);
 
const optionalStr = z.string().optional().or(z.literal(""));
 
const optionalNum = z
  .union([z.string(), z.number()])
  .optional()
  .nullable();
 
// ── General ───────────────────────────────────────────────
const generalSchema = z.object({
  validationType:  requiredStr("Validation type"),
  businessName:    requiredStr("Business name"),
  businessPhone:   requiredStr("Business phone").regex(/^\d{8,15}$/, "Phone must be 8–15 digits"),
  businessAddress: requiredStr("Business address"),
  postalCode:      requiredStr("Postal code"),
  contactName:     requiredStr("Customer name"),
  billingName:     requiredStr("Billing name"),
  mpan:            optionalStr,
});
 
// ── Electricity ───────────────────────────────────────────
const electricitySchema = z.object({
  elecSupplier:       requiredStr("Current supplier"),
  elecAccount:        optionalStr,
  elecMonthYear:      optionalStr,
  elecContractEnd:    requiredStr("Contract end date"),
  //elecPayment:        requiredStr("Payment method"),
  elecPayment:        optionalStr,
  //elecMeterType:      requiredStr("Meter type"),
    elecMeterType:      optionalStr,
  elecDayRate:        optionalNum,
  elecNightRate:      optionalNum,
  elecEveRate:        optionalNum,
  elecEseRate:       requiredStr("EAC rate"),
  elecStandingCharge: optionalNum,
  elecSupplyNumber:   requiredStr("Supply number"),
  //elecAvgBill:        requiredStr("Average bill amount"),
  elecAvgBill:          optionalStr,
  elecBillType:       optionalStr,
  elecBillRange:      optionalStr,
  elecMSN:            optionalStr,
});
 
// ── Gas ───────────────────────────────────────────────────
const gasSchema = z.object({
  gasSupplier:          requiredStr("Current supplier"),
  gasAccount:           optionalStr,
  gasMonthYear:         optionalStr,
  gasContractEnd:       requiredStr("Contract end date"),
 // gasPayment:           requiredStr("Payment method"),
 gasPayment:             optionalStr,
  gasAnnualConsumption: requiredStr("Annual consumption"),
  gasDayRate:           optionalNum,
  gasStandingCharge:    optionalNum,
  gasMprnNumber:        requiredStr("MPRN number"),
  //gasAvgBill:           requiredStr("Average bill amount"),
  gasAvgBill:             optionalStr,
  gasBillingFreq:       optionalStr,
  gasBillRange:         optionalStr,
  gasMSN:               optionalStr,
});
 
// ── Quality Review ────────────────────────────────────────
const qualitySchema = z.object({
  email: z
    .string()
    .optional()
    .refine(
      (val) => !val || val === "" || z.string().email().safeParse(val).success,
      { message: "Enter a valid email" }
    ),
  leadDisposition: requiredStr("Lead disposition"),
  agentFeedback:   optionalStr,
  qualityFeedback: optionalStr,
});
 
// ── Helper to safely extract issues ──────────────────────
function extractErrors(result, errorsObj) {
  if (!result.success && result.error && Array.isArray(result.error.issues)) {
    result.error.issues.forEach((issue) => {
      const key = issue.path[0];
      if (key && !errorsObj[key]) {
        errorsObj[key] = issue.message;
      }
    });
  }
}
 
// ── Full validator ────────────────────────────────────────
export function validateLeadForm(form) {
  const rawType = form.validationType?.trim();
 
  const showElec =
    rawType === "Electricity Only" ||
    rawType === "Electricity + Gas";
 
  const showGas =
    rawType === "Gas Only" ||
    rawType === "Electricity + Gas";
 
  const errors = {};
 
  // General — always validate
  extractErrors(generalSchema.safeParse(form), errors);
 
  // Electricity — only if shown
  // if (showElec) {
  //   extractErrors(electricitySchema.safeParse(form), errors);
  // }
 
  // Electricity — only if shown
if (showElec) {
  extractErrors(electricitySchema.safeParse(form), errors);
 
  // Bottom line of Supply No (MPAN core) — required, exactly 13 digits
  const mpanDigits = (form.mpan || "").replace(/\D/g, "");
 
  if (!mpanDigits) {
    errors.mpan = "Bottom line of Supply No (MPAN) is required";
  } else if (mpanDigits.length !== 13) {
    errors.mpan = `MPAN must be exactly 13 digits (${mpanDigits.length}/13)`;
  }
}
 
  // Gas — only if shown
  if (showGas) {
    extractErrors(gasSchema.safeParse(form), errors);
  }
 
  // Quality — always validate
  extractErrors(qualitySchema.safeParse(form), errors);
 
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
 
